import { render, staticRenderFns } from "./FormInformarProblema.vue?vue&type=template&id=30db96a2&scoped=true&"
import script from "./FormInformarProblema.vue?vue&type=script&lang=js&"
export * from "./FormInformarProblema.vue?vue&type=script&lang=js&"
import style0 from "./FormInformarProblema.vue?vue&type=style&index=0&id=30db96a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db96a2",
  null
  
)

export default component.exports